import { render, staticRenderFns } from "./panel-toggle.vue?vue&type=template&id=28c632a8&"
import script from "./panel-toggle.vue?vue&type=script&lang=ts&"
export * from "./panel-toggle.vue?vue&type=script&lang=ts&"
import style0 from "./panel-toggle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports